<template>
  <div class="carta-proposta-orcamento">
    <!-- <div class="titulo-fluxos"> SELECIONAR ORÇAMENTOS </div>
    <div class="subtitulo-fluxos"> Selecione quais orçamentos vão estar na carta-proposta </div> -->
    <g-titulo-steps
    titulo="SELECIONAR ORÇAMENTOS"
    subtitulo="Selecione quais orçamentos vão estar na carta-proposta"
    :imagemEmpresa = imagemEmpresa
    />

<!-- Nome do protudo -- data- autorização - prazo maximo -->
          <g-data-table
          TextoVazio="Nenhum Orçamento"
            Titulo="Tabela"
            :colunas="colunasTabelastep1"
            :valores="OrcamentoArray"
            :NumeroLinhas="6"
            :Filtros="Filtro"
            :temColunaSelecao="true"
            ref="tabela"
            dataKey="orcamentoId"
            :Editavel="false"
            :EscondeColunaBotao="true"
        >
        </g-data-table>

    <!-- popup após selecionar um orçamento -->
    <PDialog :closable="true" v-model:visible="popup" :modal="true">

        <p class="Titulo-PopUp">DETALHES SOLICITAÇÃO</p>

        <PTextArea rows="5" cols="45" ></PTextArea>

        <div class="botaoFinalizar">
        <g-button
        largura="100%"
        negritoTexto
        tamanhoTexto="15px"
        @click="paginafinalizada">
        VOLTAR
        </g-button>
        </div>

    </PDialog>

    <div class="buttons-next-back">
      <div class="button-next">
         <g-button
         tipo="amarelo"
         altura="35px"
         largura="100%"
         negritoTexto 
         @click="step2()"
         >CONTINUAR</g-button>
      </div>
      <div class="button-back">
         <g-button
         tipo="cinza" 
         altura="35px"
         largura="100%"
         negritoTexto 
         @click="VoltarInicio()"
         >VOLTAR</g-button>
      </div>
    </div>
  </div>
</template>

<script>
import GerarCartaPropostaOrcamento from './GerarCartaPropostaOrcamento.js'
export default GerarCartaPropostaOrcamento
</script>

<style scoped>

/* -------------- */

 .Titulo-Inicial{
    text-align: center;
    font: normal normal 600 20px/31px Montserrat;
    color: #4F2C19;
    opacity: 1;
    margin-top: 10px;;
    margin-top: 30px;
 }
 .Titulo-PopUp{
    text-align: center;
    font: normal normal 600 15px/31px Montserrat;
    color: #4F2C19;
    opacity: 1;
    margin-bottom: 20%;

 }
 .Subtitulo-Inicial{
    text-align: center;
    font: normal normal normal 12px/19px Montserrat;
    letter-spacing: 0px;
    color: #8A8A8A;
    opacity: 1
 }
 .margim{
    margin-left: 12%;
    width: 80%;
 }



 @media (min-width:310px) {
   .container-botoes { grid-area: 3 / 1 / 4 / 2; align-self: flex-end; }
   .container-botoes {
      display: grid;
      grid-template-columns: 100%;
      grid-template-rows: repeat(2, auto);
      grid-row-gap: 15%;
      margin-top: 60px;
      padding: 2rem 0.5rem 1.5rem 0.5rem;
   }

   .button-continuar { grid-area: 1 / 1 / 2 / 2; width: 100%; }
   .button-voltar { grid-area: 2 / 1 / 3 / 2; width: 100%; }
 }

 @media (min-width:368px) {
   .container-botoes{
      padding: 2rem 1rem 1.5rem 1rem;
   }
   .buttons-next-back {
      margin: 50px 20px 30px;
   }
 }
 @media (min-width:400px) {
   .buttons-next-back {
   margin: 50px 0 30px;
   }
}

 @media (min-width:600px) {
   .container-botoes {
      margin-top: 70px;
      padding: 2rem 5rem 1.5rem 5rem;
   }
 }

 @media (min-width:801px) {
   .container-botoes {
      margin-top: 90px;
      padding: 2rem 8rem 1.5rem 8rem;
   }
 }

 @media (min-width:1025px) {

   .button-voltar { grid-area: 1 / 1 / 2 / 2; width: 70%; justify-self: flex-end; }
   .button-continuar { grid-area: 1 / 2 / 2 / 3; width: 70%; justify-self: flex-start; }

   .container-botoes {
      width: 100%;
      display: flex;
      flex-direction: row-reverse;
      align-items: baseline;
      gap: 15px;
      padding: 2rem 14rem 1.5rem 14rem;
   }

 }

 @media (min-width:1281px) {
   .container-botoes{
      padding: 2rem 20rem 1.5rem 20rem;
   }
 }

</style>
